import { Product } from '@/types';
import React from 'react';
import RatingsBadge from '../review/rating-badge';
import { Tabs, Tab } from '@nextui-org/react';
import ProductReviews from '../review/product-reviews';
import pluralize from 'pluralize';

const ProductReviewWidget = ({ product }: { product: Product }) => {
  const {
    id,
    ratings,
    total_reviews,
    shop,
    store_review_amount,
    store_review_score,
  } = product;

  if (total_reviews <= 0 && store_review_amount <= 0) return null;

  return (
    <>
      <div className="flex items-center gap-2 text-lg">
        {store_review_amount} {total_reviews <= 0 ? 'Shop ' : ''}{' '}
        {pluralize('Review', store_review_amount)}
        <RatingsBadge rating={store_review_score} className="max-w-[140px]" />
        {/* <p className="text-sm text-gray-500">
          {`${store_review_score} out of 5`}
        </p> */}
      </div>
      {typeof window !== 'undefined' ? (
        <Tabs
          variant="underlined"
          aria-label="Review Tabs"
          className="!ml-0 !mt-4"
          disableAnimation
          classNames={{
            panel: '!m-0',
            tab: '!pl-0',
            tabList: '!pl-0',
            cursor: '!w-full',
          }}
        >
          {ratings > 0 && total_reviews > 0 && (
            <Tab
              key="product"
              title={
                <div className="flex gap-2">
                  Product Reviews ({total_reviews})
                </div>
              }
            >
              <ProductReviews
                productId={id}
                ratings={ratings}
                initialData={product.reviews}
                hideHeading
              />
            </Tab>
          )}
          <Tab
            key="store"
            title={
              <div className="flex gap-4">
                Shop Reviews ({store_review_amount})
              </div>
            }
          >
            <ProductReviews
              productId={id}
              storeId={shop?.id}
              ratings={ratings}
              initialData={product.shop_reviews}
              hideHeading
            />
          </Tab>
        </Tabs>
      ) : (
        <div>
          <h2 className="text-sm tracking-tight text-dark dark:text-light">
            Product Reviews ({total_reviews})
          </h2>
          <ProductReviews
            productId={id}
            ratings={ratings}
            initialData={product.reviews}
            hideHeading
          />
          <h2 className="text-sm tracking-tight text-dark dark:text-light">
            Shop Reviews ({store_review_amount})
          </h2>
          <ProductReviews
            productId={id}
            storeId={shop?.id}
            ratings={ratings}
            initialData={product.shop_reviews}
            hideHeading
          />
        </div>
      )}
    </>
  );
};

export default ProductReviewWidget;
